export default {
  methods: {
    isGuestPage() {
      const arr = [
        'login',
        'twoFactorAuth',
      ]
      return arr.indexOf(this.$route.name) !== -1
    },
    isPrintPage() {
      return this.$route.name.startsWith('print') ||
        this.$route.name.startsWith('adminPrint')
    },
  }
}
